import { Select } from '@ygtechnologies/bygr-frontend-component-library';
import React, { useState } from 'react';
import { DocumentCategoriesDto } from '@/services/projects';
import { AlertBanner, Button, ButtonBar, Dialog } from '@ygtechnologies/rubus-ui';
interface ProjectSelectCategoriesModalProps {
    values: DocumentCategoriesDto[];
    selectedValue?: number;
    isOpen: boolean;
    onSave(selectedValue: number): Promise<void>;
    toogle: () => void;
}

const ProjectSelectCategoriesModal: React.FC<ProjectSelectCategoriesModalProps> = ({
    isOpen,
    onSave,
    values,
    selectedValue,
    toogle,
}) => {
    const [showWarning, setShowWarning] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const options = values.map((x) => {
        return { value: x.id, label: x.name };
    });
    const [selValue, setSelValue] = useState(options.find((x) => x.value === selectedValue) || null);
    const save = async () => {
        if (selValue) {
            setIsSaving(true);
            await onSave(selValue.value);
            setIsSaving(false);
        } else {
            setShowWarning(true);
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && toogle()}>
            <Dialog.Content contentWidth="sm">
                <Dialog.Header>Select document category hierarchy</Dialog.Header>
                <Select options={options} value={selValue} onChange={(x) => setSelValue(x as { value: number; label: string } | null)} />
                {showWarning && <AlertBanner type="danger">You have to pick a category to continue.</AlertBanner>}
                <ButtonBar>
                    <ButtonBar.Right>
                        <Button variant="tertiary" onClick={toogle}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={save} loading={isSaving}>
                            Save
                        </Button>
                    </ButtonBar.Right>
                </ButtonBar>
            </Dialog.Content>
        </Dialog>
    );
};

export default ProjectSelectCategoriesModal;
